import styled from '@emotion/styled';
import { StyledResetButton } from '~/shared/components';
import { m } from 'framer-motion';
import { breakpoints } from '~/theme';

export const StyledFilterTrigger = styled(StyledResetButton)<{ isOpen: boolean }>(
    ({ theme, isOpen }) => ({
        position: 'relative',
        height: theme.spaces[5],
        fontFamily: theme.fonts.body,
        fontSize: theme.fontSizes.lg,
        border: isOpen ? `1px solid ${theme.traits.line.color}` : '1px solid transparent',
        borderBottom: 'none',
        padding: 0,
        backgroundColor: isOpen ? theme.colors.light : 'none',
        /*
         * This translate insures the trigger covers the full width border on
         * the bottom of filters container, creating a white break on the border,
         * connecting the button with the filters container
         * */
        '&:hover': {
            backgroundColor: theme.colors.light30,
        },
        '&:after': {
            position: 'absolute',
            content: '""',
            display: isOpen ? 'block' : 'none',
            width: '100%',
            height: '1px',
            backgroundColor: theme.colors.light,
            left: 0,
            bottom: '-1px',
        },
        [breakpoints.md]: {
            padding: ` 0 ${theme.spaces[2]}`,
        },
        [breakpoints.lg]: {
            padding: ` 0 ${theme.spaces[3]}`,
        },
    })
);

export const StyledFilterGroup = styled(m.div)({
    padding: 0,
    position: 'relative',
});

export const StyledGroupTitle = styled.label(({ theme }) => ({
    marginRight: theme.spaces[2],
    fontFamily: theme.fonts.body,
    fontSize: theme.fontSizes.sm,
    cursor: 'pointer',
}));

export const StyledChunkSizeFilters = styled.div({
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 1fr)',
});

export const StyledRangeContainer = styled.div({
    display: 'inline-block',
    minWidth: 290,
});

export const StyledSizeContainer = styled.div(({ theme }) => ({
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'flex-start',
    gap: theme.spaces[3],
}));

export const StyledOtherContainer = styled.div({
    flex: '1 1 100%',
    columns: '200px auto',
});
